import React from "react";
import { StrategyFundsSidebarElement } from "./elements/strategy-funds.component";
import { StrategyStatusSidebarElement } from "./elements/strategy-status.component";
import { StrategyInfoSidebarElement } from "./elements/strategy-info.component";
import { WalletContext } from "../../global/contexts";

export function TraderPageSidebar() {
  const { wallet } = React.useContext(WalletContext);

  let sidebar =
    wallet?.connectionState === "CONNECTED" ? (
      <aside className="etx-body__aside">
        <div className="etx-container Container pv-0">
          <StrategyFundsSidebarElement />
        </div>

        <div className="etx-container Container pt-50 tab-m:pt-25 pb-0">
          <StrategyInfoSidebarElement />
        </div>

        <div className="etx-container Container pt-50 tab-m:pt-25 pb-0">
          <StrategyStatusSidebarElement />
        </div>
      </aside>
    ) : (
      <aside className="etx-body__aside">
        <div className="etx-container Container pv-0"></div>
      </aside>
    );
  return sidebar;
}
